// extracted by mini-css-extract-plugin
export default {"tile":"tile_tile__R-t76","title":"tile_title__zBzxq","description":"tile_description__Hd-dm","descriptionContent":"tile_descriptionContent__VGA58","footer":"tile_footer__pjMXz"};